<template>
  <router-link
    class="table-router-link"
    :to="{ name: 'Card', params: { id: row.id } }"
    target="_blank"
  >
      {{ value ? value : row.user.full_name }}
  </router-link>
</template>

<script>

export default {
  name: "router-link-to-card-column-template",
  components: {},

  props: {
    row: {type: Object, required: true},
    value: {type: String, required: false, default: null},
  },

  data() {
    return {}
  },
  mounted() {
  },
  watch: {},
  computed: {},
  methods: {},

}
</script>

<style>
.table-router-link{
  text-decoration: none;
}
</style>